import { addCss } from '@shared/easyfy.utils';

export const isMobile = () => (window.innerWidth <= 768 ? true : false);

export const isDesktop = () => (window.innerWidth >= 1100 ? true : false);

export const toggleProp = (el: HTMLElement): void => {
  !('open' in el.dataset) ? (el.dataset.open = '') : delete el.dataset.open;
};

export const animationEnded = (el: Element | HTMLElement, func: EventListenerOrEventListenerObject) =>
  el.addEventListener('animationend', func, { once: true });

export const deleteCookie = (name: string) => {
  const expirationTime = Date.now() - 30 * 60 * 1000;
  document.cookie = `${name}= ; expires=${new Date(expirationTime).toUTCString()}; path=/; domain=${window.location.hostname}`;
};

export const setCookie = (contentCookie: string, cookieName: string, expirationDate?: Date) => {
  deleteCookie(cookieName);

  const expiration = expirationDate || new Date();

  if (!expirationDate) {
    expiration.setTime(expiration.getTime() + 30 * 60 * 1000); // default to 30 minutes
  }

  document.cookie = `${cookieName}=${contentCookie}; expires="${expiration.toUTCString()}"; path=/; domain=${window.location.hostname}`;
};

export const delay = (ms: number) => new Promise((resolve) => setTimeout(resolve, ms));

export const clearContent = (container) => {
  container.innerHTML = '';
};

export const replaceContent = (container, data: string, type: string = 'append', clearData: boolean = true) => {
  if (clearData) container.innerHTML = '';

  const content = document.createRange().createContextualFragment(data).firstElementChild;

  switch (type) {
    case 'after':
      container.after(content);
      break;
    case 'replaceInnerHtml':
      container.innerHTML = content.innerHTML;
      break;
    case 'append':
    default:
      container.appendChild(content);
      break;
  }
};

export const createElementWithClasses = (tag: string, classes: string | string[], innerText?: string | undefined): HTMLElement => {
  const element = document.createElement(tag);
  addCss(element, classes);

  if (innerText) element.innerText = innerText;
  return element;
};

export const createLink = (href: string | undefined, text: string, classes: string | string[]): HTMLAnchorElement => {
  const link = document.createElement('a');
  link.href = href || '#';
  link.innerText = text;
  addCss(link, classes);
  return link;
};

export const createEventButton = (text: string, event: string, classes: string | string[]): HTMLButtonElement => {
  const button = document.createElement('button');
  button.innerText = text;
  button.dataset.event = event;
  addCss(button, classes);
  return button;
};

export interface UrlHistoryContent {
  appendType: string;
  data: string;
}
